namespace TabAurous.Retail {
    export interface GiftVoucherItemDetailsRow {
        Id?: number;
        TransItemId?: number;
        TransId?: number;
        RefVoucherId?: number;
        UniqueNo?: string;
        GiftMasterId?: number;
        Code?: string;
        FixedName?: string;
        Value?: number;
        Amount?: number;
        MinInvoiceValue?: number;
        Expiry?: string;
        IsRedeemed?: boolean;
        IsPartial?: boolean;
        IsIssued?: boolean;
        RedeemedValue?: number;
        RedeemedDate?: string;
    }

    export namespace GiftVoucherItemDetailsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'UniqueNo';
        export const localTextPrefix = 'Retail.GiftVoucherItemDetails';
        export const lookupKey = 'Retail.GiftVoucherItemDetails';

        export function getLookup(): Q.Lookup<GiftVoucherItemDetailsRow> {
            return Q.getLookup<GiftVoucherItemDetailsRow>('Retail.GiftVoucherItemDetails');
        }
        export const deletePermission = 'Retail:GiftVoucherIssue:Delete';
        export const insertPermission = 'Retail:GiftVoucherIssue:Add';
        export const readPermission = '*';
        export const updatePermission = 'Retail:GiftVoucherIssue:Edit';

        export declare const enum Fields {
            Id = "Id",
            TransItemId = "TransItemId",
            TransId = "TransId",
            RefVoucherId = "RefVoucherId",
            UniqueNo = "UniqueNo",
            GiftMasterId = "GiftMasterId",
            Code = "Code",
            FixedName = "FixedName",
            Value = "Value",
            Amount = "Amount",
            MinInvoiceValue = "MinInvoiceValue",
            Expiry = "Expiry",
            IsRedeemed = "IsRedeemed",
            IsPartial = "IsPartial",
            IsIssued = "IsIssued",
            RedeemedValue = "RedeemedValue",
            RedeemedDate = "RedeemedDate"
        }
    }
}
